export default __webpack_public_path__ + "static/mobile_sek2_KV13-7b199b8e1fe34f0598a72b520c0d2e28.mp4";